// <핫이슈 박스 컴포넌트>

// 2021.11.01 기획서 기준  광고까지 총 5개 박스

// 5. 기타
// CCI 관리자에서 Type 1~4 및 구글 AD 및 인하우스 배너 수동입력 가능
// 수동 입력되는 배열순서는 시간으로 입력 또는 순서번호로 입력, 단 구글 광고는 순서로만 입력
// Google AD 사이즈 : 336 * 280
// 인하우스 배너 : 가로 고정, 세로는 최소/최대 높이 제한
// 모든 링크에 통계 파라미터 삽입 div=hotissue

import React from 'react';
// import Link from 'next/link';

export default function Box (props) {
  const srcUrl = '/html/pc/hotissue.htm';
  // const linkUrl = props.link_url; // 링크 url

  return (
    <>
      <div className='hotmodule_box_w_type6'>
        <a className='hmb_link'>
          <div className='hmb_ad_w'>
            <iframe display='block' title='배너광고' src={srcUrl} width='100%' height='100%' scrolling='no' frameBorder='0' marginWidth='0' marginHeight='0' align='hotissue' />
          </div>
        </a>
      </div>
    </>
  );
}// Finish default function Box()
